module.exports = __webpack_public_path__ + "static/media/Fusionex.22c07122.jpeg";